import {ProjectsDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'UPDATE_PROJECT';

export async function updateProject(token: string, projectId: number | string, payload: Record<string, unknown>) {
    try {
        const result = await ProjectsDao.updateProject(token, projectId, payload);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la mise à jour du projet',
            error: error
        });
    }
}
